import { ColumnValue, Tab, Table, Text, Stack, styled } from '@/theme/index';
import { commaFormat, useScreenSize } from '@/utils/index';

export interface RoutineMaintenanceSchedule {
  category: string;
  item: string;
  mileage: number;
  months: number;
}

export interface MajorMaintenanceSchedule {
  interval: string;
  services: ColumnValue[][];
}

export const StyledTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.grey[400],
  fontSize: '0.813rem',
  fontWeight: 'normal',
  textDecoration: 'none',
  padding: theme.spacing(1),
  marginRight: theme.spacing(1.5),
  border: 'none',
  borderRadius: theme.spacing(0.5),
  minWidth: 'unset',
  minHeight: 'unset',
  '&[data-active-tab="true"], :hover': {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
  },
}));

const StyledTable = styled(Table)(({ theme }) => ({
  marginTop: theme.spacing(1),

  thead: {
    th: {
      backgroundColor: theme.palette.background.paper,
      fontSize: '0.875rem',
      fontWeight: 'bold',
      padding: theme.spacing(0.5),
      borderBottom: 'none',
    },
  },
}));

export const RoutineTableContent = (
  schedules: RoutineMaintenanceSchedule[]
): JSX.Element => {
  const { isTablet } = useScreenSize();

  if (isTablet) {
    return (
      <Stack direction="column" spacing={2} mt={1}>
        {schedules.map((schedule) => {
          const rows: ColumnValue[][] = [
            ['Item', schedule.item || ''],
            ['Mileage', schedule.mileage ? commaFormat(schedule.mileage) : ''],
            ['Months', schedule.months ? schedule.months.toString() : ''],
          ];

          return (
            <Stack direction="column" spacing={0.5}>
              <Text>{schedule.category}</Text>
              <Table className="striped" rows={rows} />
            </Stack>
          );
        })}
      </Stack>
    );
  }

  const tableHeader = ['Category', 'Item', 'Mileage', 'Months'];

  const rows = schedules.map((schedule) => {
    const value: ColumnValue[] = [
      schedule.category || '',
      schedule.item || '',
      schedule.mileage ? commaFormat(schedule.mileage) : '',
      schedule.months ? schedule.months.toString() : '',
    ];
    return value;
  });

  return <StyledTable className="striped" headers={tableHeader} rows={rows} />;
};

export const MajorTableContent = (
  schedules: MajorMaintenanceSchedule[]
): JSX.Element => {
  return (
    <Stack direction="column" spacing={2} width="100%">
      {schedules.map((maintenance, index) => {
        return (
          <Stack direction="column" spacing={0.5} key={index}>
            <Text fontWeight="bold" fontSize="1.125rem">
              {commaFormat(parseInt(maintenance.interval))} Miles Services
            </Text>
            <Table className="striped" rows={maintenance.services} />
          </Stack>
        );
      })}
    </Stack>
  );
};
